import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output", "cursor"]
  static values = {
    words: { type: Array, default: [] },
    typeSpeed: { type: Number, default: 90 },
    deleteSpeed: { type: Number, default: 50 },
    pauseBetween: { type: Number, default: 2000 }
  }

  connect() {
    this.index = 0
    this.charIndex = 0
    this.deleting = false

    if (this.wordsValue.length === 0) return

    this.outputTarget.textContent = ""
    this.type()
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  type() {
    const word = this.wordsValue[this.index]

    if (!this.deleting) {
      this.charIndex++
      this.outputTarget.textContent = word.slice(0, this.charIndex)

      if (this.charIndex === word.length) {
        this.timeout = setTimeout(() => {
          this.deleting = true
          this.type()
        }, this.pauseBetweenValue)
        return
      }
      this.timeout = setTimeout(() => this.type(), this.typeSpeedValue)
    } else {
      this.charIndex--
      this.outputTarget.textContent = word.slice(0, this.charIndex)

      if (this.charIndex === 0) {
        this.deleting = false
        this.index = (this.index + 1) % this.wordsValue.length
        this.timeout = setTimeout(() => this.type(), this.typeSpeedValue * 2)
        return
      }
      this.timeout = setTimeout(() => this.type(), this.deleteSpeedValue)
    }
  }
}
